import { KUORI_WORDMARK } from "@expho/design-system/logo";
import type { PageContent } from "../content/index.js";
import { InstagramIcon, MessageIcon } from "../shared/icons.js";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, whatsappHref } from "../shared/links.js";
import type { V2FootCopy } from "./content.js";

export function PhotoWordmark({ src }: { readonly src: string }) {
  const { width, height, path } = KUORI_WORDMARK;
  return (
    <svg
      class="mark"
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label="Kuori"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <clipPath id="kuori-mark-clip">
          <path d={path} clip-rule="evenodd" />
        </clipPath>
      </defs>
      <g clip-path="url(#kuori-mark-clip)">
        <rect width={width} height={height} class="mark-base" />
        <image
          class="mark-photo"
          href={src}
          x={-width * 0.15}
          y={-height * 0.6}
          width={width * 1.3}
          height={height * 2.2}
          preserveAspectRatio="xMidYMid slice"
        />
      </g>
    </svg>
  );
}

export interface EndingProps {
  readonly copy: V2FootCopy;
  readonly content: PageContent;
}

export function Ending({ copy, content }: EndingProps) {
  return (
    <footer class="end" id="contato" data-theme="dark">
      <div class="wrap">
        <div class="end-cta">
          <div>
            <h2 class="end-title serif">{copy.title}</h2>
            <p class="end-note">{copy.note}</p>
          </div>
          <div class="end-actions">
            {copy.demo ? (
              <a class="pill pill-ink" href={copy.demo.href}>
                {copy.demo.label}
              </a>
            ) : null}
            <a class={copy.demo ? "pill pill-line" : "pill pill-ink"} href={whatsappHref(content)}>
              <MessageIcon size={18} />
              {copy.action}
            </a>
          </div>
        </div>
        <PhotoWordmark src="/assets/photos/hero-pista.webp" />
        <div class="end-meta">
          <p class="micro">{copy.rights}</p>
          <a
            class="end-social"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener"
            aria-label={`Instagram @${INSTAGRAM_HANDLE}`}
          >
            <InstagramIcon size={22} />
          </a>
        </div>
      </div>
    </footer>
  );
}
